import { Dispatch, useCallback, useState } from "react";

export interface RequestRecipt {
  vCodeId: number;
  phone: string;
  sentAt: Date;
}
export interface States {
  requested: RequestRecipt | null;
  verified: boolean;
  vCode: string;
  open: boolean;
}
export type Action =
| {kind: 'open'}
| {kind: 'close'}
| {kind: 'vCode', vCode: string}
| {kind: 'clearVCode'}
| {kind: 'codeRequested', requested: RequestRecipt}
| {kind: 'resetRequested'}
| {kind: 'verified'}

export const reducer = (v: States, action: Action):States => {
  switch (action.kind) {
    case 'resetRequested': { return ({...v, requested: null}) }
    case 'codeRequested': { return ({...v, verified: false, requested: action.requested}) }
    case 'verified': { return ({...v, verified: true}) }
    case 'clearVCode': { return ({...v, vCode: '', open: false}) }
    case 'vCode': { return ({...v, vCode: action.vCode}) }
    case 'open': { return ({...v, open: true}) }
    case 'close': { return ({...v, 
      open: false,
      // vCode: '',
      // requested: null,
    }) }
    default: return v
  }
}

export const useSendCodeCountDown = (states: States, dispatch: Dispatch<Action>) => {
  
  const [innerStates, setInnerStates] = useState({
    countDown: null as number|null,
    stopped: false,
    timers: [] as number[],
  })
  const disposeTimer = () => {
    setInnerStates(v => {
      if (v.timers.length > 0) {
        for(const timer of v.timers) {
          window.clearInterval(timer)
        }
        v.timers.length = 0
      }
      return ({...v, stopped: false, countDown: null})
    })
  }

  const clearCountDown = () => {
    dispatch({kind: 'resetRequested'})
    disposeTimer()
  }
  const onRequestCodeSuccessCb = useCallback((phone:string, resp:{data:{id:any,verificationCodeId:number}}) => {
    setInnerStates(v => {
      if (v.timers.length > 0) { return v }
  
      const sentAt = new Date()
      window.setTimeout(() => {
        dispatch({kind: 'codeRequested', 
          requested: { 
            vCodeId: resp.data.verificationCodeId, 
            phone: phone, 
            sentAt, 
          }
        })
      })
      const timer = window.setInterval(() => {
        const n = 60 - Math.floor((Date.now() - sentAt.getTime()) / 1000)
        if (n >= 0) {
          setInnerStates(v => v.countDown === n ? v : ({...v, countDown: n}))
        } else {
          disposeTimer()
        }
      }, 250)
      v.timers.push(timer)
      return ({...v })
    })
  }, [])

  const onRequestCodeSuccess = (phone:string) => (resp:{data:{id:any,verificationCodeId:number}}) => {
    onRequestCodeSuccessCb(phone, resp)
  }
  return {
    clearCountDown,
    onRequestCodeSuccess,
    states: {
      innerStates,
      setInnerStates,
    }
  }
}

